module.exports = __webpack_public_path__ + "cab0f81406483ce1664966a685938fa6.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/outfit-fancy-dress-s.png
// module id = 1339
// module chunks = 0